import { createFileRoute, Navigate } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { ProposalDashboard } from "@/modules/proposal-builder/components/dashboard/ProposalDashboard";
import { useBrandSettings } from "@/modules/proposal-builder/hooks/useBrandSettings";

export const Route = createFileRoute("/proposal-builder/")({
  component: ProposalBuilderIndexRoute,
});

function ProposalBuilderIndexRoute() {
  const { data: brand, isLoading, isError } = useBrandSettings();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#0f0f0f] text-white">
        <Loader2 className="h-5 w-5 animate-spin text-white/40" />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#0f0f0f] px-6 text-center text-white">
        <div>
          <p className="text-sm text-white/70">Failed to load brand settings.</p>
        </div>
      </div>
    );
  }

  if (!brand?.setup_complete) {
    return (
      <Navigate
        to="/proposal-builder/setup"
        search={{ redirect: "/proposal-builder" }}
      />
    );
  }

  return <ProposalDashboard />;
}